import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=8d7b3212&scoped=true&"
import script from "./expend.vue?vue&type=script&lang=js&"
export * from "./expend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7b3212",
  null
  
)

export default component.exports